import React from "react";
import { SovosBox, SovosIcon, SovosTypography } from "mosaic-react";
import { InfoOutlined } from "mosaic-react-icons";
import { useGlobalValue } from "../../state/GlobalProvider";
const DragAndDropInfo = ({
  csvDelimiter
}) => {
  const {
    i18n
  } = useGlobalValue();
  return /*#__PURE__*/React.createElement(SovosBox, {
    sx: {
      height: "40px",
      backgroundColor: "#F0F5FA",
      width: "100%",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(SovosIcon, {
    children: /*#__PURE__*/React.createElement(InfoOutlined, null)
  }), /*#__PURE__*/React.createElement(SovosTypography, {
    sx: {
      paddingLeft: "10px"
    }
  }, "Drag and drop your files to the table to upload data.", " ", csvDelimiter ? i18n`Applied CSV delimiter: ${csvDelimiter}` : ""));
};
export default DragAndDropInfo;